export default __webpack_public_path__ + "static/no-food-ee2546c69896a179e1965e1998bef6bc.png";